module.exports = __webpack_public_path__ + "img/pro_02defer_ok.1f6766d0.png";